import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import {
  BuildIcon,
  DesignIcon,
  LaunchIcon,
  MaintenanceIcon,
  PlaneIcon,
  TestIcon,
} from "../../../app-constants";
const WorkFlow = [
  {
    logo: PlaneIcon,
    title: "Plan",
    description:
      "The development process usually starts with proper planning based on in-depth market research on user needs, regulatory requirements, and analysis.",
    count: "01",
  },
  {
    logo: DesignIcon,
    title: "Design",
    description:
      "Our design team develops realistic and attractive UI and UX forms for telemedicine apps, based on the attained project requirements.",
    count: "02",
  },
  {
    logo: BuildIcon,
    title: "Build",
    description:
      "Our in-house developers equipped with recent technologies transform the design into production-ready apps of telemedicine that are stable and scalable.",
    count: "03",
  },
  {
    logo: TestIcon,
    title: "Test",
    description:
      "Our expert developers ensure efficient integration with third-party APIs and external devices to provide proficient functionality in our telehealth app products.",
    count: "04",
  },
  {
    logo: LaunchIcon,
    title: "Launch",
    description:
      "Through QA, we utilize functional testing, interface testing, and reconstruction testing to guarantee that the telemedical app fully lives up to the quality standards.",
    count: "05",
  },
  {
    logo: MaintenanceIcon,
    title: "Maintenance",
    description:
      "When the testing is done successfully and the client approves, we proceed to the official launch of the telemedicine app and you can also rely on us for post-launch operations.",
    count: "06",
  },
];
const Workflow = () => {
  return (
    <div className="workflow p-100 tekrevol_gray_bg">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Our Telemedicine App Development <span>Process</span>
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <p>
              At a telemedicine app development firm, we are guided by a
              well-prepared and streamlined process to develop and deliver
              effective telemedicine solutions. We take a step-by-step,
              detail-oriented approach ranging from initial planning to
              execution of the final launch that results in user-friendly and
              qualitative healthcare apps as per the unique requirements of
              medical practitioners and patients.
            </p>
          </Col>
        </Row>
        <Row className="workflow_secion">
          {WorkFlow.map((item, index) => (
            <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="my-auto">
              <div className="workflow_items">
                <div className="item_name">
                  <span>{item.count}</span>
                  {item.title}
                  <div className="item_icon"> {item.logo}</div>
                </div>
                <p>{item.description}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default Workflow;
